module.exports = __webpack_public_path__ + "img/totalicon04.e0a1a62a.png";